export const AUTH_STORAGE_KEY = "maeiz-customer-auth";

export const APP_ROLE = "customer" as const;

export type AppRole = typeof APP_ROLE;
